"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseTranslation = require("nicbase-translation");

var _constants = require("../../constants");

require("./tour-duration.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TourDuration = function TourDuration(_ref) {
  var duration = _ref.duration,
      status = _ref.status;
  var positiveDuration = Math.max(0, duration);

  var _splitDuration = (0, _constants.splitDuration)(positiveDuration / 60000),
      hours = _splitDuration.hours,
      minutes = _splitDuration.minutes;

  if (!positiveDuration || status === _constants.TOUR_STATUS.WAITING) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "tour-duration-container"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.infoBlock.noInformationAvailable",
      tagName: "span"
    }));
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "tour-duration-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "time"
  }, hours, " h ", minutes, " min"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "description"
  }, status === _constants.TOUR_STATUS.RUNNING && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.infoBlock.currentTourDuration",
    tagName: "span"
  }), status === _constants.TOUR_STATUS.FINISHED && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.infoBlock.tourDuration",
    tagName: "span"
  })));
};

TourDuration.propTypes = {
  duration: _propTypes["default"].number.isRequired,
  status: _propTypes["default"].oneOf([_constants.TOUR_STATUS.WAITING, _constants.TOUR_STATUS.RUNNING, _constants.TOUR_STATUS.FINISHED])
};
TourDuration.defaultProps = {
  status: _constants.TOUR_STATUS.WAITING
};
var _default = TourDuration;
exports["default"] = _default;